import { render } from "./PropertiesPanel.vue?vue&type=template&id=25400bed&scoped=true&ts=true"
import script from "./PropertiesPanel.vue?vue&type=script&lang=ts"
export * from "./PropertiesPanel.vue?vue&type=script&lang=ts"

import "./PropertiesPanel.vue?vue&type=style&index=0&id=25400bed&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25400bed"]])

export default __exports__